import { render, staticRenderFns } from "./PersonalDataForm.html?vue&type=template&id=a48cd0c2&external"
import script from "./PersonalDataForm.ts?vue&type=script&lang=ts&external"
export * from "./PersonalDataForm.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports